import { Service } from '@toeverything/infra';

import { FolderTemplateList } from '../entities/folder-list';
import { TemplateDocList } from '../entities/list';
import { TemplateDocSetting } from '../entities/setting';

export class TemplateDocService extends Service {
  public readonly list = this.framework.createEntity(TemplateDocList);
  public readonly setting = this.framework.createEntity(TemplateDocSetting);
  public readonly folderList = this.framework.createEntity(FolderTemplateList);
}
